/* global braintree */
import i18n from 'l10n';
import Handlebars from 'handlebars';
import _ from 'underscore';
import GenericView from 'js/views/generic.view';
import Template from 'js/templates/credits.buy.hbs';
import CreditsBuyBundlesModel from 'js/models/credits.buy.bundles.model';
import CreditsBuyBundlesCollection from 'js/models/credits.buy.bundles.collection';
import UpgradeTypeCollection from 'js/models/upgrade.type.collection';
import ExpandTypeCollection from 'js/models/expand.type.collection';
import braintree from 'braintree';
import dhtmlx from 'dhtmlxAdapter';
import {el, on, tagName, template} from "../adapters/backbone-decorators";

require('jqueryUI');
require('metroHelpers');
require('metroHint2');

@el("#buy-credit-container")
@tagName('span')
@template(Template)
class CreditsBuyView extends GenericView {

    accountTypeAndVatPercentage = null;
    changingFlagStatus = false;
    isGeolocationAddonActive = false;
    geoAddonExpirationDate = "";
    geoCoding = false;
    addonCost = -1;
    hostedFieldsInstance = null;
    isAzure = false;

    constructor() {
        super();
        this.upgradeTypeCollection = new UpgradeTypeCollection();
        this.creditsBuyBundlesCollection = new CreditsBuyBundlesCollection();
        this.expandTypeCollection = new ExpandTypeCollection();
        this.loadCredits();
        console.info("initialize BuyCredits");
    }

    events() {
        return {
            'click .disabledClickEvent': function (e) {
                e.preventDefault();
            },
        };
    }

    render() {
        super.render();
    }

    renderCollection() {
        if (this.creditsBuyBundlesCollection.length === 0) {
            $.Notify.error(i18n.t("credits.nocreditsloaded"));
        }

        const jsonData = this.upgradeTypeCollection.toJSON();

        const {basic, classic, premium} = _.extend({
            basic: [],
            classic: [],
            premium: []
        }, _.groupBy(jsonData, x => x.upgradeAccountType.toLowerCase()));

        const html = this.template({
            upgradeTypeBasic: basic,
            upgradeTypeClassic: classic,
            upgradeTypePremium: premium,
            bundles: this.creditsBuyBundlesCollection.toJSON(),
            expandType: this.expandTypeCollection.toJSON(),
            accountTypeAndVatPercentage: this.accountTypeAndVatPercentage
        });

        this.$el.html(html);

        if (basic.length > 0) $('#basic-upgrade').show();
        if (classic.length > 0) $('#classic-upgrade').show();
        if (premium.length > 0) $('#premium-upgrade').show();

        if (basic.length > 0 && classic.length > 0 && premium.length > 0 ||
            basic.length <= 0 && classic.length <= 0 && premium.length <= 0) {
            $('#overlay').hide();
        } else {
            $('#overlay').show();
        }

        this.$('[data-i18n]').i18n();
        this.getUserInfo();


        if (this.expandTypeCollection.length < 1) {
            $('#expansion-bundle').prop('disabled', 'disabled');
        }

        if (jsonData.length <= 0) {
            $("#upgrade-bundle").prop("disabled", true);
        }

    }

    async loadCredits() {
        try {
            await this.upgradeTypeCollection.fetch();
            await this.creditsBuyBundlesCollection.fetch();
            await this.expandTypeCollection.fetch();
            this.accountTypeAndVatPercentage = await $.ajaxDefaultQ({
                url: "/CampaignCloud/CreditsController/AccountTypeAndVatPercentage",
                type: 'GET',
                dataType: "json"
            });

            console.log("Vat", this.accountTypeAndVatPercentage);
            this.isAzure = this.accountTypeAndVatPercentage.isAzure;
            console.log(this.isAzure);
            await this.upgradeTypeCollection.fetch();
        } catch (e) {
            console.log(e);
        }

        this.renderCollection();
        console.info("Fetching bundles");
    }

    getUrlVars() {
        const vars = {};
        window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
            vars[key] = value;
        });
        return vars;
    }

    getAmount(vatPercentage, model, property) {
        return (model.get(property) + model.get(property) * vatPercentage / 100).toFixed(2);
    }

    getBundleData() {
        const selector = ".bundleCheckbox:checked";
        let bundleId = this.$('#credit-bundle').find(selector).val() || 0;
        let upgradeId = this.$('#upgrade-bundle').find(selector).val() || 0;
        let expansionId = this.$('#expansion-bundle').find(selector).val() || 0;
        const {vatPercentage} = this.accountTypeAndVatPercentage;
        const getAmount = _.partial(this.getAmount.bind(this), vatPercentage);
        return {bundleId, upgradeId, expansionId, getAmount};
    }

    getBundleDataByType(bundleId, upgradeId, expansionId, getAmount) {
        let customCreditsCount, upMonths, account, text, euros;
        if (bundleId > 0) {
            const bundle = this.creditsBuyBundlesCollection.get(bundleId);
            const credits = bundle.get('credits');
            const amount = getAmount(bundle, 'amount');
            text = i18n.t("credits.paymentagreement", {credits, amount});
            customCreditsCount = (bundleId === '1000' ? bundle.get('credits') : -1);
        } else if (upgradeId > 0) {
            const upgradeType = this.upgradeTypeCollection.get(upgradeId);
            this.upgradeTypeCollection.get(upgradeId);
            upMonths = upgradeType.get('months');
            account = upgradeType.get('upgradeAccountType');
            euros = getAmount(upgradeType, 'euros');
            text = i18n.t("credits.paymentagreementupgrade", {euros, account, count: upMonths});
        } else if (expansionId > 0) {
            const expandType = this.expandTypeCollection.get(expansionId);
            upMonths = expandType.get('months');
            account = expandType.get('accountType');
            euros = getAmount(expandType, 'euros');
            text = i18n.t("credits.paymentagreementexpand", {euros, account, count: upMonths});
        }
        return {customCreditsCount, upMonths, account, text};
    }

    @on("click #paypal")
    async paypalPayment() {
        $('#paypal, #bundle-selection, #profile-view').attr('disabled', true);
        let {bundleId, upgradeId, expansionId, getAmount} = this.getBundleData();

        let messageId = this.getUrlVars().messageId || null;

        let {customCreditsCount, upMonths, account, text} =
            this.getBundleDataByType(bundleId, upgradeId, expansionId, getAmount);

        const result = await dhtmlx.confirm({
            type: "confirm",
            text,
            ok: i18n.t("message.yes"),
            cancel: i18n.t("message.no")
        });

        if (result) {
            $("#spinner").show();
            const url = '/CampaignCloud/PaymentController/setPaypalExpressCheckout';
            const formValues = {
                bundleId: bundleId,
                messageId: messageId,
                upgrade: [upgradeId, account, upMonths],
                expansion: [expansionId, account, upMonths],
                customCreditsCount
            };

            try {
                const {status, LocationUri} = await $.ajaxDefaultQ({
                    url: url,
                    type: 'POST',
                    dataType: "json",
                    data: formValues,
                    traditional: true
                });

                if (status === 'success') {
                    console.info(LocationUri);
                    window.open(LocationUri, '_self');
                } else if (status === 'fail') {
                    throw new Error(status);
                }
            } catch (e) {
                $("#spinner").hide();
                $('#paypal').attr('disabled', false);
                $('#bundle-selection').attr('disabled', false);
                $('#profile-view').attr('disabled', false);
                dhtmlx.alert(i18n.t("credits.paypalcheckouterror"));
            }
        }

    }

    @on("click #purchase")
    doBraintreePayment() {
        //TODO check if var text is actually ever used.
        const $spinner = $("#spinner")
            .css("margin-top", "60%")
            .show();
        let {bundleId, upgradeId, expansionId, getAmount} = this.getBundleData();
        let {customCreditsCount, upMonths, account} =
            this.getBundleDataByType(bundleId, upgradeId, expansionId, getAmount);

        if (this.hostedFieldsInstance) {
            this.hostedFieldsInstance.tokenize(async (tokenizeErr, payload) => {
                if (tokenizeErr) {
                    console.error(tokenizeErr.message);
                    dhtmlx.alert(tokenizeErr.message);
                    return;
                }
                const url = '/CampaignCloud/PaymentController/doBraintreePayment';
                const formValues = {
                    bundleId: bundleId,
                    payment_nonce: payload.nonce,
                    upgrade: [upgradeId, account, upMonths],
                    expansion: [expansionId, account, upMonths],
                    customCreditsCount
                };

                const knownErrors = [3000, 4001, 4003, 4004, 4006];

                try {
                    const response = await $.ajaxDefaultQ({
                        url: url,
                        type: 'POST',
                        dataType: "json",
                        data: formValues,
                        traditional: true
                    });
                    const {status, error, transactionId} = response;

                    $("#spinner").hide();
                    if (status === 'success') {
                        this.teardownBraintreePayment();
                        $("#credits").hide();
                        await this.checkTransaction(transactionId);
                        $.Notify.show(i18n.t("transaction.successful"));
                    } else if (status === 'fail') {
                        console.error(`Error in transaction: ${transactionId}`);

                        if (error) { //error in card payment
                            if ((error >= 2000 && error <= 2010)
                                || knownErrors.indexOf(parseInt(error)) > -1) {
                                dhtmlx.alert(i18n.t(`braintree.code${error}`));
                            } else {
                                dhtmlx.alert(i18n.t("braintree.code", {code: error}));
                            }
                        } else {
                            $.Notify.error(i18n.t("credits.carderror"));
                        }
                    }
                    console.info(response);

                } catch (e) {
                    $("#spinner").hide();
                    $.Notify.error(i18n.t("credits.carderror"));
                    console.error(e);
                }
            });
        } else {
            $spinner.hide();
            console.log("No hostedFieldsInstance");
            $.Notify.error(i18n.t("credits.carderror"));
        }
    }

    async checkTransaction(tId) {
        const url = '/CampaignCloud/PaymentController/checkTransaction';

        const response = await $.ajaxDefaultQ({
            url: url,
            type: 'POST',
            dataType: "json",
            data: {
                transactionId: tId
            },
            traditional: true
        });

        const {
            status,
            transactionId,
            transactionType,
            transactionAmount,
            transactionStatus,
            cardType,
            cardBin,
            cardLast4,
            cardExpDate,
            cardHolder,
            transactionCreated,
            transactionUpdated,
            transactionMerchantId
        } = response;

        if (status === 'success') {

            $("#transactId").text(transactionId);
            $("#transactType").text(transactionType);
            $("#transactAmount").text(transactionAmount);
            $("#transactStatus").text(transactionStatus);
            $("#cardBin").text(cardBin);
            $("#cardLast4").text(cardLast4);
            $("#cardType").text(cardType);
            $("#cardExpDate").text(cardExpDate);
            $("#cardHolder").text(cardHolder);
            $("#transactCreatedAt").text(transactionCreated);
            $("#transactUpdatedAt").text(transactionUpdated);
            $("#transactMerchantId").text(transactionMerchantId);
            $("#transactionDetails").show();

        } else if (status === 'fail') {
            throw response;
        }
        console.info(response);
    }

    @on('click #closeTransactionReport')
    closeTransactionReport() {
        window.open('Credits.htm', '_self');
    }

    @on("click #btree")
    async initBraintreePayment() {
        const url = '/CampaignCloud/PaymentController/initializeBraintree';
        $("#spinner").show();
        $('#purchase').addClass('disable-button');

        function btCreateClientCB(clientErr, clientInstance) {
            if (clientErr) {
                console.error(clientErr);
                return;
            }
            createHostedFields.call(this, clientInstance);
            $("#spinner").hide();
        }

        function btFailure() {
            $("#spinner").hide();
            $('#paypal').attr('disabled', false);
            dhtmlx.alert(i18n.t("credits.carderror"));
        }

        function btHostedFieldsCB(hostedFieldsErr, hostedFieldsInstance) {
            if (hostedFieldsErr) {
                console.error(hostedFieldsErr.message);
                return;
            }

            hostedFieldsInstance.on('empty', function () {
                $('#card-image').removeClass();
                $('#cardForm').removeClass();
            });

            hostedFieldsInstance.on('validityChange', function (event) {
                const formValid = Object.keys(event.fields).every(key => event.fields[key].isValid);
                $('#purchase').toggleClass('disable-button', !formValid);
            });

            function setCvv(fourDigits) {
                hostedFieldsInstance.setAttribute({
                    field: 'cvv',
                    attribute: 'placeholder',
                    value: fourDigits ? '1234' : '123'
                });
            }

            hostedFieldsInstance.on('cardTypeChange', function ({cards}) {
                if (cards.length === 1) {
                    $('#cardForm').removeClass().addClass(cards[0].type);
                    $('#card-image').removeClass().addClass(cards[0].type);
                    // Change the CVV length for AmericanExpress cards
                    if (cards[0].code.size === 4) setCvv(true);
                } else
                    setCvv();
            });

            console.info("hostedFields created");
            this.hostedFieldsInstance = hostedFieldsInstance;
            $('.payment-methods-row').hide();
            $('#cardForm').show();
        }

        function createHostedFields(client) {

            braintree.hostedFields.create({
                client,
                styles: {
                    'input': {
                        'font-size': '16px',
                        'font-family': 'courier, monospace',
                        'font-weight': 'lighter',
                        'color': '#ccc',
                        'transition': 'color 0.1s'
                    },
                    ':focus': {
                        'color': 'black'
                    },
                    '.valid': {
                        'color': '#00aa00'
                    },
                    '::-webkit-input-placeholder': {
                        'color': 'rgba(0,0,0,0.6)'
                    },
                    ':-moz-placeholder': {
                        'color': 'rgba(0,0,0,0.6)'
                    },
                    '::-moz-placeholder': {
                        'color': 'rgba(0,0,0,0.6)'
                    },
                    ':-ms-input-placeholder': {
                        'color': 'rgba(0,0,0,0.6)'
                    }
                },
                fields: {
                    number: {
                        selector: '#card-number',
                        placeholder: '4111 1111 1111 1111'
                    },
                    cvv: {
                        selector: '#cvv',
                        placeholder: '123'
                    },
                    expirationDate: {
                        selector: '#expiration-date',
                        placeholder: 'MM/YYYY'
                    }
                }
            }, btHostedFieldsCB.bind(this));
        }

        try {
            const response = await $.ajaxDefaultQ({
                url: url,
                type: 'POST',
                dataType: "json",
                traditional: true
            });
            const {status, clientToken} = response;
            if (status === 'success') {
                console.info(response);
                braintree.client.create({
                    authorization: clientToken
                }, btCreateClientCB.bind(this));

            } else if (status === 'fail') {
                btFailure();
                console.info(response);
            }

        } catch (e) {
            btFailure();
        }
    }

    @on("click #cancel-purchase")
    teardownBraintreePayment() {
        const $spinner = $("#spinner");
        $spinner.show();
        $('#card-type').text('Card');
        $('#card-image').removeClass();
        const $cardForm = $('#cardForm');
        $cardForm.removeClass();
        $('.payment-methods-row').show();
        $cardForm.hide();

        if (this.hostedFieldsInstance) {
            this.hostedFieldsInstance.teardown();
        }
        $spinner.hide();
    }

    @on("click #show-verification")
    showBraintreeVerification() {
        const url = '/CampaignCloud/PaymentController/showBraintreeVerification';
        $.ajaxDefaultQ({
            url: url,
            type: 'POST',
            dataType: "json",
            traditional: true
        }).done(function (response) {
            if (response.status === 'success') {
                console.info(response.uri);
                window.open(response.uri, '_blank');
            } else if (response.status === 'fail') {
                dhtmlx.alert(response.error);
            }
        }).fail(function (response) {
            dhtmlx.alert(response.error);
        });
    }

    bundleSelection(currentCheckbox) {
        const typeOfBundle = currentCheckbox.parent().parent().parent().data("id");
        const selectedBundleId = currentCheckbox.val();
        const $upgrade = $('#upgrade-bundle');
        const $credit = $('#credit-bundle');
        const $expansion = $('#expansion-bundle');
        const {vatPercentage} = this.accountTypeAndVatPercentage;
        const eurVal = val => `${val.toFixed(2)} €`;

        function bundleTypeToTotal(bundle, type) {
            const totalExcVat = bundle.get(type);
            const totalVat = totalExcVat * vatPercentage / 100;
            const totalIncVat = totalExcVat + totalVat;
            return {totalIncVat, totalVat, totalExcVat};
        }

        function toggleStuff(on) {
            $('#summary-table').toggle(!!on);
            $('#paypal, #braintree').prop("disabled", !on);
        }

        function handleBundle(collection, type, otherBundles) {
            const bundle = collection.get(selectedBundleId);
            if (bundle) {
                const {totalExcVat, totalVat, totalIncVat} = bundleTypeToTotal(bundle, type);

                $('#totalexcvat').text(eurVal(totalExcVat));
                $('#totalvat').text(eurVal(totalVat));
                $('#totalincvat').text(eurVal(totalIncVat));

                otherBundles.forEach(this.unSelectOtherBundles);
            }
            toggleStuff(bundle);
        }

        if (typeOfBundle === "credit-bundle") {
            handleBundle.call(this, this.creditsBuyBundlesCollection, 'amount', [$upgrade, $expansion]);
        } else if (typeOfBundle === "upgrade-bundle") {
            handleBundle.call(this, this.upgradeTypeCollection, 'euros', [$expansion, $credit]);
        } else if (typeOfBundle === "expansion-bundle") {
            handleBundle.call(this, this.expandTypeCollection, 'euros', [$upgrade, $credit]);
        }
    }

    getUserInfo() {
        const handler = function ({geoCoding, subscriptionLevel}) {
            this.geoCoding = geoCoding;
            this.subscriptionLevel = subscriptionLevel;
            this.getActiveAddon();
            this.getGeoAddonCost(subscriptionLevel);
        };

        $.getDefaultJSONQ('/CampaignCloud/UserInfo', null, handler.bind(this));
    }

    async buyGeocodingAddon() {
        const geoAddonCost = await this.getGeoAddonCost(this.subscriptionLevel);
        if (!geoAddonCost) return;
        let checked = false;
        let withMessage = false;
        if (this.isGeolocationAddonActive) {
            const result = await dhtmlx.confirm({
                type: "confirm",
                text: i18n.t("credits.settoonwhileactive", {credits: this.addonCost}),
                ok: i18n.t("message.yes"),
                cancel: i18n.t("message.no")
            });
            checked = !!result;
        } else {
            /* TODO Replace with model fetch */
            const response = await $.ajaxDefaultQ({
                url: '/CampaignCloud/UserInfo',
                type: 'get'
            });
            if (response.creditsAvailable > geoAddonCost) {
                const result = await dhtmlx.confirm({
                    type: "confirm",
                    text: i18n.t("credits.activateaddon", {
                        credits: this.addonCost,
                        count: this.addonCost
                    }),
                    ok: i18n.t("message.yes"),
                    cancel: i18n.t("message.no")
                });
                if (result) { //user pressed OK
                    try {
                        const {outcome} = await $.ajaxDefaultQ({
                            url: "/CampaignCloud/CreditsController/buyGeocodingAddon/",
                            dataType: "json",
                            type: "POST"
                        });
                        switch (outcome) {
                            case "OK":
                                await dhtmlx.alert({
                                    text: i18n.t("credits.billedforaddon", {credits: this.addonCost})
                                });
                                checked = withMessage = true;
                                location.reload();
                                break;
                            case "NOT_ENOUGH_CREDITS":
                                await dhtmlx.alert({
                                    text: i18n.t("credits.notenoughcredits")
                                });
                                break;
                            case "ALREADY_ACTIVE":
                                $.Notify.show(i18n.t(`generic.=${outcome}`));
                                checked = true;
                                break;
                            default:
                                $.Notify.error("Error: ", {outcome: i18n.t(`generic.=${outcome}`)});
                                break;
                        }

                    } catch (re) {
                        console.error(`Error: ${re}`);
                    }
                } else { //user pressed CANCEL
                    this.geoCoding = true;
                }
            } else {
                await dhtmlx.alert({
                    text: i18n.t("credits.notenoughcredits")
                });
            }
        }
        await this.toggleStatus(checked, withMessage);
    }

    async getActiveAddon() {
        let $geocodingExpiration = $("#geocoding-expiration-date");
        const boundToggleGeolocation = this.toggleGeolocation.bind(this);
        try {
            const {outcome, addon} = await $.ajaxDefaultQ({
                url: "/CampaignCloud/CreditsController/getActiveAddon",
                dataType: "json"
            });
            const $geocodingFlag = $("#geocoding-flag");
            switch (outcome) {
                case "OK":
                    this.isGeolocationAddonActive = true;
                    this.geoAddonExpirationDate = i18n.t("credits.expiringon") + " " + Handlebars.helpers.timestamp(addon.deactivationDate, "L");
                    $geocodingFlag.find("input").prop("checked", this.geoCoding);
                    $geocodingExpiration.attr('title', this.geoAddonExpirationDate);
                    break;
                case "ALREADY_ACTIVE":
                    this.isGeolocationAddonActive = true;
                    await this.toggleStatus(this.geoCoding, false);
                    $geocodingFlag.find("input").prop("checked", this.geoCoding);
                    break;
                case "NOT_FOUND":
                    this.geoCoding = false;
                    this.isGeolocationAddonActive = false;
                    await this.toggleStatus(false, false);
                    $geocodingFlag.find("input").prop("checked", false);
                    $geocodingExpiration.attr('title', i18n.t("credits.notactivated"));
                    break;
                default:
                    this.isGeolocationAddonActive = false;
                    await this.toggleStatus(false, false);
                    $geocodingFlag.find("input").prop("checked", false);
                    $geocodingExpiration.attr('title', i18n.t("credits.notactivated"));
                    break;
            }
            $geocodingFlag.bind("click", boundToggleGeolocation);

        } catch (e) {
            this.isGeolocationAddonActive = false;
            $("#geocoding-flag").bind("click", boundToggleGeolocation);
            $geocodingExpiration.attr('title', i18n.t("credits.notactivated"));
        }
    }

    toggleGeolocation() {
        if (!this.changingFlagStatus) {
            this.changingFlagStatus = true;
            const status = !this.geoCoding;
            if (status) this.buyGeocodingAddon();
            else this.toggleStatus(status, true);
        }
    }

    async toggleStatus(status, withMessage) {
        try {
            const {outcome} = await $.ajaxDefaultQ({
                url: `/CampaignCloud/UserInfo/toggleGeoLocation/${status}`,
                dataType: "json",
                type: "POST"
            });
            if (outcome === "OK") {
                if (withMessage) {
                    $.Notify.show(i18n.t("generic.attributechanged", {outcome: i18n.t(`generic.=${outcome}`)}));
                }
                this.geoCoding = status;
            }
        } catch (re) {
            console.error(`Error: ${re}`);
        }
        this.changingFlagStatus = false;
        $("#geocoding-flag").find("input").prop("checked", this.geoCoding);
        const title = this.isGeolocationAddonActive ? this.geoAddonExpirationDate : i18n.t("credits.notactivated");
        $("#geocoding-expiration-date").attr('title', title);
    }

    async getGeoAddonCost(subLevel) {
        try {
            const resp = await $.ajaxDefaultQ({
                url: `/CampaignCloud/CreditsController/getGeoAddonCost/${subLevel}`,
                dataType: "json"
            });
            if (resp !== null) {
                this.addonCost = resp;
                $("#geocoding-cost").text(resp);
            } else console.error("Could not get the cost");
            return resp;
        } catch (resp) {
            console.info(`Error: ${resp}`);
            return null;
        }
    }

    unSelectOtherBundles(el) {
        const checkedCheckbox = $(el).find(".bundleCheckbox:checked");
        $(checkedCheckbox).prop("checked", false);
    }

    @on("click .bundleRow")
    triggerBundleSelection(e) {
        const bundleElement = $(e.currentTarget).find(".bundleCheckbox");
        $(bundleElement).prop("checked", true);

        const isCustomCreditBundleSelected = $(e.currentTarget).attr("id") === "customCreditsSelected";
        //show accordion in case of selecting custom credit bundle
        const $accordionBtn = $("#customCreditsAccordionBtn");
        if (isCustomCreditBundleSelected || !($accordionBtn.hasClass("collapsed")))
            $accordionBtn.trigger("click");

        this.bundleSelection($(bundleElement));
    }

    @on('click #updateCustomCreditsSelectionBtn')
    async updateCustomCreditsSelection() {
        //get cost of custom credit selection, after validating the selection to be between 1-100000 and update the corresponding "bundle" block
        const $customCreditsInput = $("#customCreditsSelectionValue");
        const customCreditsValue = parseInt($customCreditsInput.val());

        const $customCreditsErrorDiv = $("#customCreditsErrorDiv");
        if (!customCreditsValue || isNaN(customCreditsValue) ||
            (typeof customCreditsValue === 'number' && (customCreditsValue < 1 || customCreditsValue > 100000))) {
            $customCreditsErrorDiv.find(".errorMessage").text(i18n.t('credits.wrongSelectionOfCustomCredits'));
            $customCreditsErrorDiv.show();
        } else {
            try {
                const {status, creditsCount, creditsCost} = await $.ajaxDefaultQ({
                    url: `/CampaignCloud/CreditsController/customCreditsCost?customCreditCount=${encodeURIComponent(customCreditsValue)}`
                });

                if (status === "OK") {
                    $customCreditsErrorDiv.hide();
                    //trigger click to close accordion
                    $("#customCreditsAccordionBtn").trigger("click");
                    const creditsTitle = i18n.t("credits.creditTitle", {count: creditsCount});
                    $("#customCreditsDiv").html(`${creditsCount} ${creditsTitle} (${creditsCost} &euro; + ${i18n.t("credits.vat")})`);

                    //add the new custom bundle in the collection, if it does not exist
                    const customCreditBundleInCollection = this.creditsBuyBundlesCollection.get(1000);

                    // if there isn't in the collection, then create a one new, else update it
                    if (!customCreditBundleInCollection) {
                         const customCreditBundleModel = new CreditsBuyBundlesModel();

                        customCreditBundleModel.set("bundleId", 1000);
                        customCreditBundleModel.set("credits", creditsCount);
                        customCreditBundleModel.set("amount", creditsCost);

                        this.creditsBuyBundlesCollection.add(customCreditBundleModel);
                    }
                    else {
                        customCreditBundleInCollection.set("credits", creditsCount);
                        customCreditBundleInCollection.set("amount", creditsCost);

                        /*
                            The set method performs a "smart" update of the collection with the passed list of models.
                            If a model in the list isn't yet in the collection it will be added;
                            if the model is already in the collection its attributes will be merged;
                            and if the collection contains any models that aren't present in the list, they'll be removed.
                            All of the appropriate "add", "remove", and "change" events are fired as this happens.
                            Returns the touched models in the collection. If you'd like to customize the behavior,
                            you can disable it with options: {add: false}, {remove: false}, or {merge: false}.

                            So here we use the `remove: false`, so the SET will update the model, without removing it first
                        */
                        this.creditsBuyBundlesCollection.set(customCreditBundleInCollection, {remove: false});
                    }

                    //trigger click to "select" the custom bundle (have the circle being changed to a green MARK)
                    $("#customCreditsSelected").trigger("click");
                    //show customCreditButton
                    $("#addCustomCreditsSelectionBtn").show();
                } else {
                    $customCreditsErrorDiv.find(".errorMessage").text(i18n.t('credits.customCreditsGenericError'));
                    $customCreditsErrorDiv.show();
                }

            } catch (e) {
                $customCreditsErrorDiv.find(".errorMessage").text(i18n.t('credits.customCreditsGenericError'));
                $customCreditsErrorDiv.show();
            }
        }
    }

    @on('click #cancelCustomCreditSelectionBtn')
    cancelCustomCreditSelection() {
        //hide accordion
        $("#customCreditsAccordionBtn").trigger("click");
        //show customCreditButton
        $("#addCustomCreditsSelectionBtn").show();
    }
}

export default CreditsBuyView;